import {useEffect} from 'react';
import {SITE_URL} from '../../content/siteContent.js';

const setMeta = (selector, attribute, value) => {
  const element = document.head.querySelector(selector);

  if (element) {
    element.setAttribute(attribute, value);
  }
};

const createSchema = (page, canonical) => {
  const graph = [
    {
      '@type': 'WebPage',
      '@id': `${canonical}#page`,
      url: canonical,
      name: page.title,
      description: page.description,
      inLanguage: 'zh-TW',
      isPartOf: {'@id': `${SITE_URL}/#website`}
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '羽球計分板',
          item: `${SITE_URL}/`
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: page.h1,
          item: canonical
        }
      ]
    }
  ];

  if (page.type === 'faq') {
    graph.push({
      '@type': 'FAQPage',
      '@id': `${canonical}#faq`,
      mainEntity: page.faqs.map(item => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer
        }
      }))
    });
  }

  if (page.type === 'howto') {
    graph.push({
      '@type': 'HowTo',
      '@id': `${canonical}#howto`,
      name: page.h1,
      description: page.description,
      inLanguage: 'zh-TW',
      step: page.sections.map((section, index) => ({
        '@type': 'HowToStep',
        position: index + 1,
        name: section.heading,
        text: section.body,
        url: `${canonical}#${section.id}`
      }))
    });
  }

  if (page.slug === 'about') {
    graph.push({
      '@type': 'AboutPage',
      '@id': `${canonical}#about`,
      name: page.h1,
      mainEntity: {'@id': 'https://homy.hk/#org'}
    });
  }

  return {
    '@context': 'https://schema.org',
    '@graph': graph
  };
};

const SeoHead = ({page}) => {
  useEffect(() => {
    const canonical = `${SITE_URL}/${page.slug}/`;
    document.title = page.title;

    setMeta('meta[name="description"]', 'content', page.description);
    setMeta('meta[property="og:title"]', 'content', page.title);
    setMeta('meta[property="og:description"]', 'content', page.description);
    setMeta('meta[property="og:url"]', 'content', canonical);
    setMeta('meta[name="twitter:title"]', 'content', page.title);
    setMeta('meta[name="twitter:description"]', 'content', page.description);
    setMeta('link[rel="canonical"]', 'href', canonical);

    document.getElementById('content-page-schema')?.remove();

    const schema = document.createElement('script');
    schema.id = 'content-page-schema';
    schema.type = 'application/ld+json';
    schema.textContent = JSON.stringify(createSchema(page, canonical));
    document.head.appendChild(schema);

    return () => schema.remove();
  }, [page]);

  return null;
};

export default SeoHead;